import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { api, unwrap } from '@/api/client';
import type { components } from '@/api/schema';

export type AccountProfile = components['schemas']['AccountProfile'];
export type ProfileInput = components['schemas']['ProfileInput'];
export type ProfileOptions = components['schemas']['ProfileOptions'];

export const usePerfil = (enabled = true) =>
  useQuery({
    queryKey: ['perfil'],
    queryFn: () => unwrap<AccountProfile>(api.GET('/api/v1/me/profile')),
    enabled,
    staleTime: 5 * 60_000,
  });

export const useOpcionesPerfil = () =>
  useQuery({
    queryKey: ['catalogos', 'perfil'],
    queryFn: () => unwrap<ProfileOptions>(api.GET('/api/v1/catalogs/profile-options')),
    staleTime: 60 * 60_000,
  });

export const useUniversidades = (q: string) =>
  useQuery({
    queryKey: ['catalogos', 'universidades', q],
    queryFn: () =>
      unwrap<string[]>(api.GET('/api/v1/catalogs/universities', { params: { query: { q } } })),
    enabled: q.trim().length >= 3,
    staleTime: 10 * 60_000,
  });

export function useGuardarPerfil() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body: ProfileInput) =>
      unwrap<AccountProfile>(api.PUT('/api/v1/me/profile', { body })),
    onSuccess: (p) => {
      qc.setQueryData(['perfil'], p);
      void qc.invalidateQueries({ queryKey: ['me'] });
    },
  });
}

export const cambiarCorreo = (email: string) =>
  unwrap<{ email: string }>(api.PUT('/api/v1/me/email', { body: { email } }));

export async function cambiarContrasena(password: string) {
  const { response } = await api.PUT('/api/v1/me/password', { body: { password } });
  if (!response.ok) await unwrap(Promise.resolve({ response }) as never);
}

export async function eliminarCuenta() {
  const { response } = await api.DELETE('/api/v1/me', { body: { confirm: 'ELIMINAR' } });
  if (!response.ok) await unwrap(Promise.resolve({ response }) as never);
}
